/**
 * Constantes de l'application
 */

// Configuration de pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  ARTICLES_PER_CATEGORY: 6,
  MAX_RECENT_ARTICLES: 5
};

// Images par défaut
export const DEFAULT_IMAGES = {
  AVATAR: "/images/content/avatar-1.png",
  ARTICLE_COVER: "/images/content/lifestyle-photo-1.png",
  ARTICLE_COVER_2X: "/images/content/lifestyle-photo-1@2x.png",
  HISTORY_PIC: "/images/content/history-pic.png",
  POST_PIC: "/images/content/post-pic.png"
};

// Couleurs des catégories
export const CATEGORY_COLORS = {
  'fitness': 'red',
  'yoga': 'green',
  'nutrition': 'orange',
  'lifestyle': 'blue',
  'mindfulness': 'purple',
  'wellness': 'pink',
  'edutio': 'blue',
  'opco': 'green',
  'formation': 'purple',
  'apprentissage': 'orange',
  'competences': 'red',
  'certification': 'pink',
  'default': 'blue'
};

// Configuration des dates
export const DATE_FORMATS = {
  SHORT: {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
  },
  LONG: {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  },
  FULL: {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }
};

// Extensions d'images supportées
export const IMAGE_EXTENSIONS = /\.(jpg|jpeg|png|gif|webp|svg)$/i;

// Configuration de l'API
export const API_CONFIG = {
  RETRY_ATTEMPTS: 3,
  TIMEOUT: 10000,
  CACHE_DURATION: 5 * 60 * 1000 // 5 minutes
};

// Messages d'erreur
export const ERROR_MESSAGES = {
  ARTICLE_NOT_FOUND: 'Article non trouvé',
  CATEGORY_NOT_FOUND: 'Catégorie non trouvée',
  LOADING_ERROR: 'Erreur lors du chargement',
  NETWORK_ERROR: 'Erreur de connexion',
  GENERIC_ERROR: 'Une erreur est survenue'
};

// Messages de chargement
export const LOADING_MESSAGES = {
  ARTICLES: 'Chargement des articles...',
  CATEGORIES: 'Chargement des catégories...',
  CONTENT: 'Chargement du contenu...',
  MORE: 'Chargement...'
};

// Textes de l'interface
export const UI_TEXTS = {
  LOAD_MORE: 'Load more',
  READ_MORE: 'Lire la suite',
  BACK_TO_LIST: 'Retour à la liste',
  SHARE: 'Partager',
  DOWNLOAD: 'Télécharger'
};
